import api from "../apiClient";

// Typeahead sends the RAW query — normalizeSmartQuery is for smart-query
// parsing and was stripping legitimate name/word tokens ("who", "for",
// "leads"...) out of people searches, silently emptying results.
export const globalSearch = (query) =>
  api.get("/search/", {
    params: { q: String(query || "").trim() },
  });
